import React from "react";
import { Box, FormLabel as ChakraFormLabel } from "@chakra-ui/react";
import propTypes from "prop-types";

const FormLabel = ({ children, showIndicator, ...props }) => {
  return (
    <ChakraFormLabel {...props}>
      {children}
      {showIndicator && (
        <Box as="span" color="red.500">
          *
        </Box>
      )}
    </ChakraFormLabel>
  );
};

FormLabel.propTypes = {
  children: propTypes.any,
  showIndicator: propTypes.bool,
};

export default FormLabel;
